/* eslint-disable */
import Vue from "vue";

const Alert = {
  show: alert => {
    Vue.swal(alert);
  }
};

export default Alert;
